import React, {Component} from 'react';
import CSSModules from 'react-css-modules'
import { Row, Col } from 'react-flexbox-grid'
import config from 'config'
import container from '../../helpers/container'
import {
  ContainerDivs,
  Link,
  LinkIcon
} from '../../components'
import Styles from './SolutionOfferSustainability.css'

@CSSModules(Styles, {allowMultiple:true})
export default class SolutionOfferSustainability extends Component {
  constructor(props) {
    super(props)
    this.state = {
      title: 'Offer sustainable investments',
      description: 'If a retirement plan doesn’t offer sustainable options, employees are being forced to assume the financial risks of unsustainable investing.',
      url: config.domain + config.routes.solutionOfferSustainability
    }
  }

  render() {
    const aysLogo = require( '../../../static/images/AsYouSow_Logo_color.svg' )

    //
    return (
      <div styleName='page'>
        {
          container.helmet(
            this.state.title,
            this.state.description,
            this.state.url
          )
        }
        <div styleName='section-top-faq-background'>
          <ContainerDivs>
            <section styleName='section-top-faq-cell'>
              <div styleName='issue-top-label'>
                SOLUTION: <span>{this.state.title}</span>
              </div>

              <h1 styleName='issue-top-headline'>
                Employees need access to sustainable investing
              </h1>

              <h2 styleName='issue-top-copy'>
                If a retirement plan doesn’t offer sustainable options, employees are being forced to assume the financial risks of unsustainable investing.
              </h2>
            </section>
          </ContainerDivs>
        </div>
        <ContainerDivs>
          <section styleName='section'>
            <Row>
              <Col xs={12} md={4}>
                <div styleName='issue-second-headline'>
                  <span style={{whiteSpace: 'nowrap'}}>&mdash;&mdash;&mdash;&mdash;</span>
                  <br/>
                  Retirement plans are still heavily invested in sustainability risks
                </div>
              </Col>
              <Col xs={12} md={8}>
                <div styleName='issue-second-copy'>
                  <p>
                    Large investors like pension plans, university endowments, and insurance companies have started moving to make sure their portfolios are properly addressing sustainability risks like climate change, gun violence, racial justice, and gender inequality. But employer-offered retirement plans are not moving fast enough to shift towards sustainable investing – in part because asset managers like Vanguard, BlackRock, and Fidelity aren’t doing enough to help them shift.
                  </p>
                  <p>
                    Retirement plans should offer sustainable investment options that are fossil free, deforestation free, gun free, prison free, weapon free, tobacco free, and invest with a gender lens. Without sustainable investment options, plan participants are forced to assume financial risks associated with unsustainable investing. Do you want to be the “investor of last resort” in fossil fuels and other risky industries, after large investors have fled?
                  </p>
                </div>
              </Col>
            </Row>
          </section>
          <section styleName='section'>
            <Row>
              <Col xs={12} md={6}>
                <div styleName='img-issue'/>
              </Col>
              <Col xs={12} md={6}>
                <div>
                  <div styleName='issue-focus-label'>
                    WHY OFFERING SUSTAINABILITY MATTERS
                  </div>
                  <div styleName='issue-focus-headline'>
                    Unsustainable investments carry financial risk
                  </div>
                  <div styleName='issue-focus-copy'>
                    <p>
                      The financial risks of investing unsustainably, like stranded assets, reputational risk, and other negative impacts of unsustainable business practices can destroy shareholder value.
                    </p>
                    <p>
                      The goal of sustainable investing is to avoid financial risks while supporting the transition to a regenerative economy that is based on justice and sustainability.
                    </p>
                    <p>
                      <Link
                        to={config.routes.eduCenterFinRisks}
                        title='Financial risks of unsustainable investments'
                        xstrong
                      >
                        Learn more<LinkIcon />
                      </Link>
                    </p>
                  </div>
                </div>
              </Col>
            </Row>
          </section>
        </ContainerDivs>
        <div styleName='section-solutions-faq-background'>
          <ContainerDivs>
            <section styleName='section section-solutions-faq'>
              <Row>
                <Col xs={12} md={6}>
                  <div styleName='section-solutions-faq-cell'>
                    <div styleName='issue-solutions-label'>
                      Who we are
                    </div>
                    <img
                      src={aysLogo}
                      alt='As You Sow'
                      styleName='ays-logo'
                    />
                    <div styleName='issue-solutions-copy'>
                      <p>
                        Invest Your Values is a project of <i>As You Sow</i>, the nation’s
                        non-profit leader in shareholder advocacy. Founded in 1992,
                        we harness shareholder power to create lasting change
                        that benefits people, planet, and profit.
                      </p>
                    </div>
                    <div styleName='issue-faqs-link'>
                      <Link
                        to={config.routes.about}
                        title='About us'
                        xstrong
                      >
                        About us<LinkIcon/>
                      </Link>
                    </div>
                  </div>
                </Col>
                <Col xs={12} md={6}>
                  <div styleName='section-solutions-faq-cell'>
                    <div styleName='issue-faqs-label'>
                      FAQs
                    </div>
                    <div styleName='issue-faqs-headline'>
                      Answers to common questions about how retirement plans and asset managers are financing unsustainable business practices.
                    </div>
                    <div styleName='issue-faqs-item'>
                      <Link
                        to={config.routes.faqs + '#do-i-have-to-sacrifice-returns-in-order-to-invest-sustainably-'}
                        title='Do I have to sacrifice returns in order to invest sustainably?'
                        xstrong
                      >
                        Do I have to sacrifice returns in order to invest sustainably?
                      </Link>
                    </div>
                    <div styleName='issue-faqs-item'>
                      <Link
                        to={config.routes.faqs + '#why-should-retirement-plans-add-a-sustainable-investment-option-'}
                        title='Why should retirement plans add a sustainable investment option?'
                        xstrong
                      >
                        Why should retirement plans add a sustainable investment option?
                      </Link>
                    </div>
                    <div styleName='issue-faqs-link'>
                      <Link
                        to={config.routes.faqs}
                        title='FAQs'
                        xstrong
                      >
                      View all >>
                      </Link>
                    </div>
                  </div>
                </Col>
              </Row>
            </section>
            <br/>
            <br/>
          </ContainerDivs>
        </div>
      </div>
    )
  }
}